// extracted by mini-css-extract-plugin
export default {"modalBody":"modal_modalBody__WuFLR","textareaDisc":"modal_textareaDisc__u6hw7","crossSvg":"modal_crossSvg__ECTKM"};